
<template>
  <main :class="loadClass">
    <div class="load-box">
      <div class="fall-ball" id="fall-b">b</div>
      <div class="fall-ball" id="fall-r">r</div>
      <div class="fall-ball" id="fall-e">e</div>
      <div class="fall-ball" id="fall-e2">e</div>
      <div class="fall-ball" id="fall-z">z</div>
      <div class="fall-ball" id="fall-i">i</div>
      <div class="fall-ball" id="fall-space"></div>
      <div class="fall-ball" id="fall-p">p</div>
      <div class="fall-ball" id="fall-r2">r</div>
      <div class="fall-ball" id="fall-o">o</div>
    </div>
  </main>
</template>

<script>

export default {
  data(){
    return {
      loadClass: 'load-outer',
      bp: ''
    }
  },
  mounted(){
    this.bp = 'Breezi-pro'.split('');
  }
}

</script>

<style>

.load-outer {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: #333237;
  animation: loadin .7s forwards;
  display: flex;
  justify-content: center;
  align-items: center;
}

.load-box {
    width: 90%;
    height: 60%;
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .fall-ball {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    background-color: rgb(0, 153, 191);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    animation: intoPlaceL 5s linear infinite;
    color: lightblue;
  }

  #fall-b {
    animation-delay: .25s;
  }

  #fall-r {
    animation-delay: .5s;
  }

  #fall-e {
    animation-delay: .75s;
  }

  #fall-e2 {
    animation-delay: 1s;
  }

  #fall-z {
    animation-delay: 1.25s;
  }

  #fall-i {
    animation-delay: 1.5s;
  }

  #fall-space {
    background-color: rgba(0, 0, 0, 0);
    animation: none;
    width: 5px;
  }

  #fall-p {
    animation-delay: 1.75s;
  }

  #fall-r2 {
    animation-delay: 2s;
  }

  #fall-o {
    animation-delay: 2.25s;
  }

  #fall-b h5 {
    animation-delay: .25s;
  }

  #fall-r h5 {
    animation-delay: .5s;
  }

  #fall-e h5 {
    animation-delay: .75s;
  }

  #fall-e2 h5 {
    animation-delay: 1s;
  }

  #fall-z h5 {
    animation-delay: 1.25s;
  }

  #fall-i h5 {
    animation-delay: 1.5s;
  }

  #fall-p h5 {
    animation-delay: 1.75s;
  }

  #fall-r2 h5 {
    animation-delay: 2s;
  }

  #fall-o h5 {
    animation-delay: 2.25s;
  }

  @keyframes intoPlaceL {
    0% {
      background-color: rgb(0, 153, 191);
    }
    30% {
      background-color: lightblue;
      margin-top: 50%;
      transform: rotateX(360deg);
    }
    70% {
      background-color: white;
      margin-top: -50%;
      transform: rotateX(360deg);
      color: rgb(0, 153, 191);
    }
    100% {
      background-color: rgb(0, 153, 191);
    }
  }

  @keyframes appearAtEnd {
    20% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
    80% {
      opacity: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/util/MobileLoading.vue